import React, { useEffect, useRef, useState } from "react";

export default function SiteHeader() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!headerRef.current?.contains(event.target)) setOpenDropdown(null);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setOpenDropdown(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("click", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("click", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const toggleDropdown = (name) => setOpenDropdown((current) => current === name ? null : name);

  return (
    <header ref={headerRef} className="site-header">
      <div className="wrap nav">
        <div className="nav-left">
          <a className="logo" href="https://www.cliqloan.com/" aria-label="CliQloan home"><img src="/images/logo-white.svg" alt="CliQloan" width="140" height="32" /></a>
          <nav aria-label="Main">
            <ul className="menu">
              <li>
                <button className="menu-btn" type="button" aria-expanded={openDropdown === "products"} aria-controls="dd-products" onClick={(event) => { event.stopPropagation(); toggleDropdown("products"); }}>Products<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg></button>
                <div className={`dropdown${openDropdown === "products" ? " open" : ""}`} id="dd-products">
                  <a href="https://www.cliqloan.com/our-products"><strong>Platform overview</strong><span>The CliQloan loan origination system, lead to lender</span></a>
                  <a href="https://www.cliqloan.com/mortgage-point-of-sale"><strong>Mortgage POS</strong><span>Digital application and borrower portal</span></a>
                  <a href="https://www.cliqloan.com/verification-engine"><strong>Document intelligence</strong><span>Guided collection and field extraction</span></a>
                  <a href="https://www.cliqloan.com/mortgage-broker-software"><strong>For brokers</strong><span>One loan file for the whole shop</span></a>
                  <a href="https://www.cliqloan.com/loan-officer-website"><strong>Loan officer websites</strong><span>Microsites that feed your leads list</span></a>
                  <a href="https://www.cliqloan.com/integrations"><strong>Integrations</strong><span>Credit, e-signature, pricing and secure tasks</span></a>
                </div>
              </li>
              <li><a className="menu-link" href="https://www.cliqloan.com/pricing">Pricing</a></li>
              {'\n'}<li><a className="menu-link" href="https://www.cliqloan.com/blog">Blog</a></li>
              <li>
                <button className="menu-btn" type="button" aria-expanded={openDropdown === "resources"} aria-controls="dd-resources" onClick={(event) => { event.stopPropagation(); toggleDropdown("resources"); }}>Resources<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg></button>
                <div className={`dropdown${openDropdown === "resources" ? " open" : ""}`} id="dd-resources">
                  <a href="https://www.cliqloan.com/glossary"><strong>Glossary</strong><span>LOS, TRID, VOE and more in plain terms</span></a>
                  <a href="https://www.cliqloan.com/faq"><strong>FAQ</strong><span>Answers about CliQloan</span></a>
                </div>
              </li>
              <li><a className="menu-link" href="https://www.cliqloan.com/about">About</a></li>
            </ul>
          </nav>
        </div>
        <div className="nav-right">
          <a className="menu-link" href="https://www.cliqloan.com/contact-us">Contact</a>
          <a className="menu-link" href="https://app.cliqloan.com/signup">Sign up</a>
          <a className="btn btn-primary" href="https://www.cliqloan.com/schedule-demo">Schedule a demo</a>
          <button className="burger" type="button" aria-expanded={mobileOpen} aria-controls="mobile-panel" aria-label={mobileOpen ? "Close menu" : "Open menu"} onClick={() => setMobileOpen((open) => !open)}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg></button>
        </div>
      </div>
      <div className={`mobile-panel${mobileOpen ? " open" : ""}`} id="mobile-panel">
        <div className="wrap">
          <p className="mpl">Products</p>
          <a href="https://www.cliqloan.com/our-products" onClick={() => setMobileOpen(false)}>Platform overview</a>
          <a href="https://www.cliqloan.com/mortgage-point-of-sale" onClick={() => setMobileOpen(false)}>Mortgage POS</a>
          <a href="https://www.cliqloan.com/verification-engine" onClick={() => setMobileOpen(false)}>Document intelligence</a>
          <a href="https://www.cliqloan.com/mortgage-broker-software" onClick={() => setMobileOpen(false)}>For brokers</a>
          <a href="https://www.cliqloan.com/loan-officer-website" onClick={() => setMobileOpen(false)}>Loan officer websites</a>
          <a href="https://www.cliqloan.com/integrations" onClick={() => setMobileOpen(false)}>Integrations</a>
          <a href="https://www.cliqloan.com/pricing" onClick={() => setMobileOpen(false)}>Pricing</a>
          {'\n'}<a href="https://www.cliqloan.com/blog" onClick={() => setMobileOpen(false)}>Blog</a>
          <p className="mpl">Resources</p>
          <a href="https://www.cliqloan.com/glossary" onClick={() => setMobileOpen(false)}>Glossary</a>
          <a href="https://www.cliqloan.com/faq" onClick={() => setMobileOpen(false)}>FAQ</a>
          <p className="mpl">Company</p>
          <a href="https://www.cliqloan.com/about" onClick={() => setMobileOpen(false)}>About</a>
          <a href="https://www.cliqloan.com/contact-us" onClick={() => setMobileOpen(false)}>Contact</a>
          <a href="https://app.cliqloan.com/signup" onClick={() => setMobileOpen(false)}>Sign up</a>
          <a className="btn btn-primary" href="https://www.cliqloan.com/schedule-demo" onClick={() => setMobileOpen(false)}>Schedule a demo</a>
        </div>
      </div>
    </header>
  );
}
